// extracted by mini-css-extract-plugin
export default {"layout":"Wes9O","number":"mVrWV","head":"mYpks","description":"eBIxW","buttonWrapper":"dkM8r","emoji":"aN5Yd"};